"use strict";

define('model/authority',['./base'], function (Model) {
  var Authority = Model.extend({
    idAttribute: 'authority'
  });
  return Authority;
});

